import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';

@Component({
  selector: 'app-sidebar-menu',
  standalone: true,
  imports: [CommonModule,RouterModule],
  templateUrl: './sidebar-menu.component.html',
  styleUrls: ['./sidebar-menu.component.scss']
})
export class SidebarMenuComponent {

  collapsed: boolean = true;

  constructor( private router: Router) { }

  shouldHideButton(): boolean {
    const currentUrl = this.router.url;
    const hideContent = currentUrl.startsWith('/cursos/');
    hideContent ? this.collapsed = true : false;
    return hideContent
  }

  toggleCollapse(){
    this.collapsed = !this.collapsed;
  }
}
